"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/file-pdf.svg.js",
    _path;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _path || (_path = React.createElement("path", {
    d: "M14 3l5.4 5.4v10.8a1.8 1.8 0 01-1.8 1.8H6.8A1.8 1.8 0 015 19.2V4.8C5 3.801 5.801 3 6.8 3H14zm-3.684 11.333a.995.995 0 00-.802.37l-.03-.311H8.7v4.388h.847v-1.494a.988.988 0 00.776.334c.377 0 .677-.147.898-.44.222-.295.333-.686.333-1.174v-.044c0-.508-.109-.906-.325-1.195-.217-.29-.521-.434-.912-.434zm4.486-1.271h-.85v1.617a.97.97 0 00-.764-.346c-.385 0-.688.146-.91.44-.222.292-.333.686-.333 1.18 0 .524.113.932.339 1.226.225.294.525.441.898.441a.996.996 0 00.814-.395l.041.337h.765v-4.5zm-7.324 3.63a.483.483 0 00-.342.125.426.426 0 00-.136.329c0 .132.045.24.135.323.09.083.204.125.343.125a.49.49 0 00.345-.125.42.42 0 00.135-.323.426.426 0 00-.136-.329.487.487 0 00-.344-.126zM16.853 13c-.368 0-.653.098-.857.294-.204.197-.307.473-.307.828v.27h-.471v.62h.471v2.55h.85v-2.55h.63v-.62h-.63v-.255c0-.3.16-.449.478-.449.101 0 .187.01.257.027l.01-.656a1.98 1.98 0 00-.431-.059zm-6.76 2.021c.2 0 .352.08.456.24.105.16.157.388.157.683 0 .662-.202.993-.606.993-.266 0-.45-.104-.554-.313v-1.298c.1-.203.282-.305.548-.305zm3.311 0c.26 0 .443.11.548.332v1.25c-.107.221-.292.332-.554.332a.506.506 0 01-.45-.238c-.104-.158-.156-.385-.156-.682 0-.662.204-.994.612-.994zM13.1 4.35V9.3h4.95L13.1 4.35z",
    fill: "#687687",
    fillRule: "evenodd",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: this
  })));
}

var _default = ReactComponent;
exports["default"] = _default;